import { createContext } from 'react'
import { CircularProgress, Typography } from '@mui/material'
import { GetCurrentUserResponseIds, useGetIdsUsersCurrent } from '@toktokdoctech/tokapi-client'
import RouterOutsideContainer from '../../routers/RouterOutsideContainer'
import { CurrentUserProviderProps } from './_props'

export const CurrentUserContext = createContext<GetCurrentUserResponseIds | null>(null)

export const CurrentUserProvider = ({ children }: CurrentUserProviderProps) => {
    const { data, error } = useGetIdsUsersCurrent()

    if (error) return <div>Error Loading User</div>

    if (!data)
        return (
            <RouterOutsideContainer>
                <CircularProgress size="3.6rem" />
                <Typography fontWeight={600} fontSize="1.6rem">
                    Chargement de l'espace TokTokDoc
                </Typography>
            </RouterOutsideContainer>
        )

    return <CurrentUserContext.Provider value={data}>{children}</CurrentUserContext.Provider>
}
